import { EnvironmentTableComponent } from './environment-table.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'src/app/shared/shared.module';
import {TableModule} from 'src/app/table/table.module';
import {PaginatorModule} from 'src/app/components/paginator/paginator.module';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import { IconsModule } from 'src/app/icons/icons.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatMenuModule} from '@angular/material/menu';
import {MatDividerModule} from '@angular/material/divider';
import { ManageColumnsModule } from 'src/app/components/manage-columns/manage-columns.module';
import { SatPopoverModule } from '@ncstate/sat-popover';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { PageLoaderModule } from 'src/app/components/page-loader/page-loader.module';
import { MatIconModule } from '@angular/material/icon';
import { EnvSchedulePopupComponentModule } from 'src/app/components/env-schedule-popup-component/env-schedule-popup-component-module';
import { RedirectionDialogModule } from 'src/app/components/redirection-dialog/redirection-dialog.module';

@NgModule({
  declarations: [
    EnvironmentTableComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TableModule,
    PaginatorModule,
    NgxSkeletonLoaderModule,
    IconsModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatDividerModule,
    ManageColumnsModule,
    SatPopoverModule,
    ClipboardModule,
    PipesModule,
    PageLoaderModule,
    MatIconModule,
    EnvSchedulePopupComponentModule,
    RedirectionDialogModule
  ],
  exports: [
    EnvironmentTableComponent
  ]
})
export class EnvironmentTableModule {
}
